import { Typography, Box, Container } from '@mui/material';
import ServicesGrid from 'features/home/components/ServicesGrid';
import SEO from 'features/shared/components/common/SEO';
import { pageSEO } from 'config/seo';
import { motion } from 'framer-motion';

export default function Servicios(){
  return (
    <>
      <SEO 
        title={pageSEO.servicios.title}
        description={pageSEO.servicios.description}
      />

      <Container maxWidth="lg" sx={{ my: { xs: 6, md: 10 } }}>
        <motion.div
           initial={{ opacity: 0, y: 20 }}
           animate={{ opacity: 1, y: 0 }}
           transition={{ duration: 0.6 }}
        >
          <Box sx={{ mb: 4, textAlign: 'center' }}>
            <Typography variant="h3" sx={{ mb: 3, fontWeight: 800, fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
              Nuestros <span style={{ color: '#1976d2' }}>Servicios</span>
            </Typography>
            <Typography variant="h6" sx={{ color: 'text.secondary', maxWidth: '700px', mx: 'auto', lineHeight: 1.6 }}>
              Ofrecemos un portafolio integral de soluciones tecnológicas adaptadas a tu negocio, con soporte y asesoría premium para cubrir todas las necesidades de tu empresa.
            </Typography>
          </Box>
        </motion.div>

        <ServicesGrid hideHeader />
      </Container>
    </>
  );
}